export default __webpack_public_path__ + "static/media/detail_mobile_9_1.698016eb.jpg";